export enum PermissionTypeEnum {
  LIVE_DOLBY = 1,
  LIVE_LINK = 2,
  ORGANIZATION_LINK = 3,
}
